import StackTrace from "stacktrace-js";
var Promise = require("es6-promise").Promise;

export default [
  "moment",
  "$window",
  "User",
  "_",
  "$analytics",
  function (moment, $window, User, _, $analytics) {
    var service = {
      error: function () {
        self.type = "error";
        log.apply(self, ["error", ...arguments]);
      },
      warn: function () {
        self.type = "warn";
        log.apply(self, ["warn", ...arguments]);
      },
      info: function () {
        self.type = "info";
        log.apply(self, ["info", ...arguments]);
      },
      log: function () {
        self.type = "log";
        log.apply(self, ["log", ...arguments]);
      },
      enabled: false,
      logs: [],
    };

    var log = function (type, ...args) {
      var message = "";

      var promises = [];

      var promises = args.map((v) => {
        if (v instanceof Error) {
          return new Promise((resolve, reject) => {
            return StackTrace.fromError(v).then(
              (stackframes) => {
                var stringifiedStack = stackframes
                  .map(function (sf) {
                    return sf.toString();
                  })
                  .join("\n");
                resolve({
                  error: v,
                  name: v.name,
                  message: v.message,
                  stack: stringifiedStack,
                });
              },
              (err) => {
                console.error("can not create stacktrace from error: ", v);
                resolve({
                  error: v,
                  name: v.name,
                  message: v.message,
                  stack: v.stack,
                });
              }
            );
          });
        } else {
          return Promise.resolve(v);
        }
      });

      Promise.all(promises).then((finalArgs) => {
        //console.log("FINAL ARGS:",finalArgs);
        var message = finalArgs
          .map((v) => {
            if (v.message) {
              if (v.stack) {
                return v.message + ": " + v.stack + "\n";
              } else {
                return v.message;
              }
            } else {
              if (_.isString(v)) {
                return v;
              } else {
                return JSON.stringify(v);
              }
              //return v;
            }
          })
          .join("");

        var stacks = finalArgs
          .filter((v) => v.stack !== undefined)
          .map((v) => v.message + ": " + v.stack);

        //console.log("sending message: ", message);

        var data = {
          type: "POST",
          url: "/error",
          contentType: "application/json",
          data: angular.toJson({
            url: $window.location.href,
            message: encodeURIComponent(message),
            type: type,
            stackTrace: stacks.length > 0 ? stacks : undefined,
            user: _.omit(User.get(), [
              "effectivePortlets",
              "portlets",
              "masterCompanies",
              "masterCompaniesFromRoles",
            ]),
          }),
        };

        if (_.isString(message)) {
          var name = message;
          var feUrl = $window.location.hash.replace("#/", "");
          if (feUrl) {
            feUrl = feUrl.substring(feUrl.indexOf("/") + 1);
          }
          var data = { category: "frontendError", label: feUrl };
          $analytics.eventTrack(name, data);

        }

        $.ajax(data);
      });

      /*var logItem = {};
    args.forEach((v)=>{
      if(v instanceof Error){
        logItem.errors.push(v);
      }
      logItem.messageArray.push(v);
    })


    var eventLogDateTime = moment().format('LLL');

    var logItem = {
      time: eventLogDateTime,
      message: args.join(""),
      type: type
    };


    var data = {
        type: "POST",
        url: "/error",
        contentType: "application/json",
        data: angular.toJson({
            url: $window.location.href,
            exception: logItem.message,
            type: logItem.type,
            stackTrace: logItem.stack,
            user : _.omit(User.get(),["effectivePortlets","portlets"])
        })
    };

    $.ajax(data);*/
    };

    return service;
  },
];

/*
export default ["$log","$window","User","_",function($log,$window,User,_){

  function sendStackFrames(message,type,stackframes){
    var stackTrace = stackframes.map(function(sf) {
      return sf.toString();
    }).join('\n');

    $.ajax({
        type: "POST",
        url: "/error",
        contentType: "application/json",
        data: angular.toJson({
            url: $window.location.href,
            message: message,
            type: type,
            stackTrace: stackTrace,
            //cause: ( args[1] || ""),
            user : _.omit(User.get(),["effectivePortlets","portlets"])
        })
    });
  }

  function sendError(args,type){
    try{


        let exception = null;
        let argArray = [].concat(args);

        var errorMessage = args[0] ? args[0].toString() : "";
        var completeMessage = argArray.join("");

        var exceptions = argArray.filter((v) =>{
          return v instanceof Error;
        });

        if(exceptions.length > 0){
          exception = exceptions [0];
        }

        if(exception) {
          StackTrace.fromError(exception).then((stackframes) =>{
            sendStackFrames(completeMessage,type,stackframes);
          }).catch((err)=> {
            console.error("error getting stacktrace from error: ", err.message, exception);
          });
        }else{
          StackTrace.generateArtificially().then((stackframes) =>{
            sendStackFrames(completeMessage,type,stackframes);
          }).catch((err) =>{
            console.error("error getting stacktrace: ", err.message, err);
          });
        }

    } catch (loggingError){
        $log.warn("Error server-side logging failed");
        $log.log(loggingError);
    }
  }

  function error(exception, cause){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.error.apply($log, arguments);
      // now try to log the error to the server side.
      sendError(arguments,"error");
  }

  function exception(exception, cause){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.error.apply($log, arguments);
      // now try to log the error to the server side.
      sendError(arguments,"exception");
  }

  function info(exception, cause){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.info.apply($log, arguments);
      // now try to log the error to the server side.
      //sendError(exception,cause,"exception");
  }

  function debug(exception, cause){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.debug.apply($log, arguments);
      // now try to log the error to the server side.
      //sendError(exception,cause,"exception");
  }

  function warn(exception, cause){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.warn.apply($log, arguments);
      // now try to log the error to the server side.
      //sendError(exception,cause,"exception");
      sendError(arguments,"warning");
  }

  function log(type){
      // preserve the default behaviour which will log the error
      // to the console, and allow the application to continue running.
      $log.log.apply($log, arguments);
      // now try to log the error to the server side.
      //sendError(exception,cause,"exception");
  }

  return {
    log : genLogFunction("info"),

  };

}];
*/



// WEBPACK FOOTER //
// ./src/ui/modules/logging/LogService.js